<template>
    <section class="account-quick-panel">
        <vue-confirm-dialog></vue-confirm-dialog>
        <div class="page-container">
        	<div class="account-details">
            	<div class="heading">
                	<h2 class="heading__h2">Your Account Details</h2>
                </div>
                <div class="info">
                	<div class="id fs-3">Member ID {{this.user.mastercard_bcn || ''}}</div>
                    <h3 class="name fs-1 mb-4">{{this.user.name || ''}}</h3>
                    <div class="email fs-3">{{this.user.email || ''}}</div>
<!--                    <div class="phone fs-3 mb-4">(212) 555-5555</div>-->
                    <br/>
                    <div v-if="this.user.cards && this.user.cards.length && this.user.cards.length > 0" class="bold fs-3">Credit Card Information </div>
                    <div v-if="this.user.cards && this.user.cards.length && this.user.cards.length > 0" class="card-info fs-3 row g-0 mb-4">
                        <div class="col-12 d-flex align-items-center">
                            <span class="card-name">Mastercard</span>
                            <span class="px-2">|</span>
                            <span class="card-no">************{{this.user.cards[0]['last_four']}}</span>
                            <span v-if="enrolledInAll" class="px-2">|</span>
                            <a href="javascript:;" @click="unEnroll" v-if="enrolledInAll"  class="fs-5 text-decoration-underline">Remove</a>
                        </div>
                        <div v-if="show_enroll_success_msg" class="alert-success" style="padding: 1vw;margin-top:1vw;">
                            Card successfully enrolled.
                        </div>

                    </div>
                    <!-- <div v-if="this.user && this.user.enrolled_in_pclo == 0"> Missing PCLO enrollment  </div> -->
                    <!-- <div v-if="this.user && this.user.enrolled_in_rakuten == 0"> Missing Rakuten enrollment  </div> -->
                    <!-- <div v-if="this.user && this.user.enrolled_in_rewards_network == 0"> Missing Rewards Network enrollment   </div> -->
                    <br/>
                    <div class="">
<!--                        <button v-if="enrolledInAll" type="button" class="btn btn-primary" @click="unEnroll">-->
<!--                            unenroll-->
<!--                        </button>-->
                        <div :class="card_removed_status_message == 'success' ? 'alert-success' : 'alert-danger'" style="padding: 1vw; margin: 1vw" v-if="card_removed_status_message">
                            {{card_removed_status_message == 'success' ? 'Card successfully removed' : 'An error occurred while trying to remove card.'}}
                        </div>
                        <div v-if="!enrolledInAll">
                            <font-awesome-icon class="ale"  icon="fa-solid fa-add fa-2xl" />    <a href="javascript:;" @click="showEnrollCard" style="text-decoration: underline">Add Card</a>
                        </div>
                        <br/>
                        <div >
                            <font-awesome-icon  icon="fa-solid fa-edit fa-2xl" />  <a href="javascript:;" @click="showChangePasswordModal"  class="text-decoration-underline">  Change Password</a>
                        </div>
                        <br/>
                        <div>
                            <font-awesome-icon  icon="fa-solid fa-edit fa-2xl" />  <a href="javascript:;" @click="showChangeEmailModal"  class="text-decoration-underline">Change Email</a>
                        </div>

                        <div v-if="false">
                            <font-awesome-icon  icon="fa-solid fa-edit fa-2xl" />  <a href="javascript:;" @click="testing_ajay"  class="text-decoration-underline">Test Ajay</a>
                        </div>
                    </div>
                </div>
            </div>
            <miles-earned-component></miles-earned-component>
        </div>
        <div class="email-communication">
            <div class="page-container d-block">
                <div class="heading">
                    <h2 class="heading__h2">Email Communication</h2>
                </div>
                <div class="row">
                    <div class="col-md-6 mb-4">
                        <input id="email_optin" v-on:change="updateEmailPreferences()" type="checkbox" name="email_optin" v-model="emailOptin" class="styled-checkbox">
                        <label for="email_optin" class="">Yes, please send me email offers &amp; promotions.</label>
                    </div>
                    <div class="col-md-3" v-show="this.showUpdateEmailPreferencesMsg" v-bind:class="(updateEmailPreferencesStatus == 'success') ? 'alert alert-success' : 'alert alert-danger'">
                        {{this.updateEmailPreferencesStatus == 'success' ? 'Updated' : 'Failed to Save'}}
                    </div>
                </div>
            </div>
        </div>
        <enroll-cards-component @reload="reload" @show_enroll_success="show_enroll_success" :doNotShowImage="true" :modalId="modalId"></enroll-cards-component>
        <change-password-component @reload="reload" ref="ChangePasswordComponent" :modalId="this.modalId"></change-password-component>
        <change-email-component @reload="reload" ref="ChangeEmailComponent"  :modalId="this.modalId"></change-email-component>
    </section>

</template>

<script>
import MilesEarnedComponent from './MilesEarnedComponent.vue';
import EnrollCardsComponent from './modals/EnrollCardsComponent.vue';
import ChangePasswordComponent from './modals/ChangePasswordComponent.vue';
import ChangeEmailComponent from './modals/ChangeEmailComponent.vue';
export default {
    components: {
        EnrollCardsComponent,
        MilesEarnedComponent,
        ChangePasswordComponent,
        ChangeEmailComponent,
    },
    name: "AccountQuickPanelComponent",
    data(){
        return {
            user: {},
            modalId: _.random(1, 10000000),
            enrolledInAll: this.getEnrolledInAll(),
            emailOptin: false,
            updateEmailPreferencesStatus: null,
            showUpdateEmailPreferencesMsg: false,
            show_enroll_success_msg: false,
            card_removed_status_message: null,

        }
    },
    methods: {
        updateEmailPreferences(event) {
            this.showUpdateEmailPreferencesMsg = false;
            this.card_removed_status_message = null;
            this.show_enroll_success_msg = false;
            // e.preventDefault();
            axios.post('/updateEmailPreferences', {
                emailOptIn: this.emailOptin
            }).then(response => {
                if(response.data.status == 'success') {

                    if(response.data.user && response.data.user.id) {
                        this.resetUserInLocalStorage(response.data.user);
                        this.user = response.data.user;
                        this.updateEmailPreferencesStatus = 'success';
                        this.showUpdateEmailPreferencesMsg = true;
                    }
                } else {
                    this.showUpdateEmailPreferencesMsg = true;
                    this.updateEmailPreferencesStatus = 'error';
                }

            })
                .catch(error => {
                    this.showUpdateEmailPreferencesMsg = true;
                    this.updateEmailPreferencesStatus = 'error';
                    if (error.response.status == 401) {
                        this.$router.push({name : 'sign_in'});
                    }
                });
        },
        reload(user) {
           this.user = user;
           this.enrolledInAll = this.getEnrolledInAll();
        },
        show_enroll_success() {
            this.show_enroll_success_msg = true;
        },
        unEnroll(e) {

            this.card_removed_status_message = null;
            this.show_enroll_success_msg = false;
            this.$confirm(
                {
                    // title: 'Are you sure?',
                    title:`Are you sure you want to remove your card? You will need to re-enroll your Mastercard in order to earn with offers.`,
                    button: {
                        no: 'No',
                        yes: 'Yes'
                    },
                    /**
                     * Callback Function
                     * @param {Boolean} confirm
                     */
                    callback: confirm => {
                        if (confirm) {
                            // e.preventDefault();
                            axios.post('/unenroll', {}).then(response => {
                                if(response.data.status == 'success') {

                                    if(response.data.user && response.data.user.id) {
                                        this.resetUserInLocalStorage(response.data.user);
                                        this.user = response.data.user;
                                        this.enrolledInAll = this.getEnrolledInAll();
                                        // this.card_removed_status_message = 'Card successfully removed.'
                                        this.card_removed_status_message = 'success';
                                    }
                                } else if(response.data.message) {
                                    // this.errors.push(response.data.message)
                                    //this.card_removed_status_message = 'An error occurred while removing card';
                                    this.card_removed_status_message = 'error';
                                } else {
                                    // this.errors.push('An error occurred. Please try again!')
                                    this.card_removed_status_message = 'error';
                                }

                            })
                                .catch(error => {
                                    console.error(error.response.status, 'here');
                                    // console.error(error.status,'here')
                                    this.card_removed_status_message = 'error';
                                    if (error.response.status == 401) {
                                        this.$router.push({name : 'sign_in'});
                                    }
                                });
                        }
                    }
                }
            )
        },
        testing_ajay() {
            axios.post('/testing_ajay', {}).then(response => {


            })
                .catch(error => {
                    console.error(error.response, 'tetsing here');
                    // console.error(error.status,'here')

                    if (error.response.status == 401) {
                        this.$router.push({name : 'sign_in'});
                    }
                });
        },
        showEnrollCard() {
            this.card_removed_status_message = null;
            this.show_enroll_success_msg = false;
            $.colorbox({
                inline: true, href:'#enroll-cards-modal-'+this.modalId, width: '80%', maxWidth:'800px', opacity: '0.90', closeButton: false,
                onComplete : function() {
                    setTimeout(function(){
                        $.colorbox.resize();
                    }, 500);
                }
            });
            $('.modal-close').on('click', function (e) {
                e.preventDefault();
                $.colorbox.close();
            });
        },
        showChangePasswordModal() {
            this.card_removed_status_message = null;
            this.show_enroll_success_msg = false;
            this.$refs.ChangePasswordComponent.resetForm();
            $.colorbox({
                inline: true, href:'#change-password-'+this.modalId, width: '80%', maxWidth:'800px', opacity: '0.90', closeButton: false,
                onComplete : function() {
                    setTimeout(function(){
                        $.colorbox.resize();
                    }, 500);
                }
            });
            $('.modal-close').on('click', function (e) {
                e.preventDefault();
                $.colorbox.close();
            });
        },
        showChangeEmailModal() {
            this.card_removed_status_message = null;
            this.show_enroll_success_msg = false;
            this.$refs.ChangeEmailComponent.resetForm();
            $.colorbox({
                inline: true, href:'#change-email-'+this.modalId, width: '80%', maxWidth:'800px', opacity: '0.90', closeButton: false,
                onComplete : function() {
                    setTimeout(function(){
                        $.colorbox.resize();
                    }, 500);
                }
            });
            $('.modal-close').on('click', function (e) {
                e.preventDefault();
                $.colorbox.close();
            });
        },
        getEnrolledInAll() {
            return (this.user && this.user.id && this.user.total_aggregators_enrolled_in == this.user.total_aggregators_count && this.user.total_aggregators_count > 0);
        },
    },
    mounted: function() {

        if(localStorage.getItem('user_obj')) {
            this.user = JSON.parse(localStorage.getItem('user_obj'));
            this.enrolledInAll = this.getEnrolledInAll();
            this.emailOptin = this.user && this.user.email_opt_in == 1 ? true : false;
        }

    }
}
</script>
